import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Fade } from '@material-ui/core';
import Routes from 'routes';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import { useAsyncWait } from 'globals/hooks/useAsyncWait';
import { isSuccessState } from 'globals/utils';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsInvitationsTable from 'ui-elements/tables/FsInvitationsTable';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { getPaperStyle } from './RecentInvitations.style';

const RecentInvitations: React.FC = () => {
  const {
    invitationsList: { status, getRecentInvitations, init: initStore },
  } = useAppContext();
  const [inStatus, setInStatus] = useState<boolean>(false);
  const linkDetails = {
    label: defaultLocales.seeAllInvitations,
    url: Routes.INVITATIONS,
  };

  useAsyncWait(setInStatus, 600);

  useEffect(() => {
    initStore();
  }, [initStore]);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );

  return (
    <Fade in={inStatus} timeout={1000}>
      <FsPaper
        title={defaultLocales.recentInvitations}
        link={linkDetails}
        style={getPaperStyle()}
      >
        <FsMinWidthScrollBox breakpointDown="md" minWidth={600}>
          <FsInvitationsTable rows={getRecentInvitations()} />
        </FsMinWidthScrollBox>
      </FsPaper>
    </Fade>
  );
};

export default observer(RecentInvitations);
